import { render, staticRenderFns } from "./promotions-welcome-bonus.vue?vue&type=template&id=0a6eef9e"
import script from "./promotions-welcome-bonus.vue?vue&type=script&lang=js"
export * from "./promotions-welcome-bonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/promotions/promotions-welcome-bonus.vue
// module id = DSn8
// module chunks = 0